const SectionHeader = ({ title }) => (
  <h2 className="section-header">
    <img className="section-header-icon" src={title.icon} alt={title.text} />
    <div className="section-header-title">{title.text}</div>
  </h2>
);

export default SectionHeader;
